import React, { useContext, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import Layout from "./Layout";
import UserContext from "../hooks/UserContext";
import apiFetch from "../utils/apiFetch";

// Какой статус "ждёт" каждую роль
const ROLE_STATUS = {
  INCIDENT_MASTER_ACTION: "MASTER_REVIEW",
  INCIDENT_CHIEF_ACTION: "LINE_CHIEF_REVIEW",
  INCIDENT_ENGINEER_ACTION: "BRANCH_ENGINEER_REVIEW",
};

export default function MonitoringLayout({ children }) {
  const { permissions } = useContext(UserContext);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    apiFetch("/api/incidents/stats")
      .then((r) => r.json())
      .then(setStats)
      .catch(() => {});
  }, []);

  // Найдём счётчик для текущей роли
  let myCount = null;
  if (stats?.by_status) {
    for (const [perm, status] of Object.entries(ROLE_STATUS)) {
      if ((permissions || []).includes(perm)) {
        myCount = (myCount || 0) + (stats.by_status[status] || 0);
      }
    }
  }

  return (
    <Layout>
      <div className="mon-wrapper">
        <aside className="mon-sidebar">
          <div className="mon-sidebar__brand">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
              <line x1="12" y1="9" x2="12" y2="13"/>
              <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
            Мониторинг
          </div>
          <nav className="mon-sidebar__nav">
            <NavLink
              to="/monitoring"
              end
              className={({ isActive }) => "mon-sidebar__link" + (isActive ? " is-active" : "")}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="8" y1="6" x2="21" y2="6"/>
                <line x1="8" y1="12" x2="21" y2="12"/>
                <line x1="8" y1="18" x2="21" y2="18"/>
                <line x1="3" y1="6" x2="3.01" y2="6"/>
                <line x1="3" y1="12" x2="3.01" y2="12"/>
                <line x1="3" y1="18" x2="3.01" y2="18"/>
              </svg>
              Рўйхат
              {myCount > 0 && (
                <span className="mon-sidebar__badge">{myCount}</span>
              )}
            </NavLink>

            <NavLink
              to="/monitoring/stats"
              className={({ isActive }) => "mon-sidebar__link" + (isActive ? " is-active" : "")}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="20" x2="18" y2="10"/>
                <line x1="12" y1="20" x2="12" y2="4"/>
                <line x1="6" y1="20" x2="6" y2="14"/>
              </svg>
              Статистика
            </NavLink>

            {(permissions || []).includes("INCIDENT_READ") && (
              <NavLink
                to="/monitoring/central"
                className={({ isActive }) => "mon-sidebar__link" + (isActive ? " is-active" : "")}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="4" width="18" height="18" rx="2"/>
                  <line x1="16" y1="2" x2="16" y2="6"/>
                  <line x1="8" y1="2" x2="8" y2="6"/>
                  <line x1="3" y1="10" x2="21" y2="10"/>
                </svg>
                Бошқарув панели
              </NavLink>
            )}
          </nav>

          <a
            href="https://t.me/uzmetbot"
            target="_blank"
            rel="noopener noreferrer"
            className="mon-sidebar__tg"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="22" y1="2" x2="11" y2="13"/>
              <polygon points="22 2 15 22 11 13 2 9 22 2"/>
            </svg>
            <div className="mon-sidebar__tg-text">
              <span>Хабарнома олиш</span>
              <span>@uzmetbot</span>
            </div>
          </a>
        </aside>
        <div className="mon-main">
          {children}
        </div>
      </div>
    </Layout>
  );
}
